"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Box = _interopRequireDefault(require("../Box"));

var _once = _interopRequireDefault(require("./once"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DEFAULT_TIMEOUT = 5000;

var _StyledBox = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Progress___StyledBox",
  componentId: "dmnh8p-0"
})(["position:absolute;left:0;bottom:0;animation-name:progress;animation-duration:", "s;animation-timing-function:linear;transform-origin:left;transform:scaleX(0);@keyframes progress{from{transform:scaleX(1);}to{transform:scaleX(0);}}", ""], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var Progress = function Progress(_ref) {
  var onClose = _ref.onClose,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? DEFAULT_TIMEOUT : _ref$timeout,
      cssFromProps = _ref.css,
      props = _objectWithoutProperties(_ref, ["onClose", "timeout", "css"]);

  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var animationEndEvent = whichAnimationEndEvent();
    var handleClose = (0, _once["default"])(onClose);
    ref.current.addEventListener(animationEndEvent, handleClose);
    return function () {
      ref.current.removeEventListener(animationEndEvent, handleClose);
    };
  }, []);
  return _react["default"].createElement(_StyledBox, _extends({
    width: "100%",
    height: 2
  }, props, {
    ref: ref,
    _css: timeout / 1000,
    _css2: cssFromProps
  }));
};

Progress.propTypes = {
  onClose: _propTypes.func.isRequired,
  timeout: _propTypes.number,
  css: _propTypes.string
};
var _default = Progress;
exports["default"] = _default;

var whichAnimationEndEvent = function whichAnimationEndEvent() {
  var t;
  var el = document.createElement('fakeelement');
  var animations = {
    'animation': 'animationend',
    'OAnimation': 'oAnimationEnd',
    'MozAnimation': 'animationend',
    'WebkitAnimation': 'webkitAnimationEnd'
  };

  for (t in animations) {
    if (el.style[t] !== undefined) {
      return animations[t];
    }
  }
};